"use strict";

const BANNER_TEMPLATE = `
    <section id="banner">
        <img src="./assets/images/banners/abra_banner-a_1600x500.png">
        <img src="./assets/images/banners/banner-cats_1600x500.png">
        <img src="./assets/images/banners/banner-kenya_1600x500.png">
        <img src="./assets/images/banners/banner-kids_1600x500.png">
    </section>
`;

const BannerComponent = Backbone.View.extend({

    className: "banner-container",
    
    isRendered: false,
    
    bannerSiema: null,

	template: _.template( BANNER_TEMPLATE ),

    afterRender: function() {
        if (this.isRendered === true) {
           let self = this;

           // The banner carousel
            this.bannerSiema = new Siema({
                selector: self.$el.find("#banner").get(0),
                loop: true,
                duration: 500,
            }).addPagination();

            // Rebind the pagination to the siema carousel
            window.addEventListener("resize", function(e) {
                self.bannerSiema.resizeHandler();
                if (document.querySelector(".bullets-container") !== null) {
                    document.querySelector(".bullets-container").remove();
                }
                self.bannerSiema.addPagination();
            });
        }
    },

    render: function() {
        this.$el.html(this.template());
        this.isRendered = true;

        return this;
    },

});